import { defineMessages } from 'react-intl';

export default defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Schedule.Step.One.ParagraphOne',
    defaultMessage:
      '<p>Programs you’ve saved that require an assessment for admission (for example, an audition, test, interview, etc.) are listed on this page.</p>',
    description: 'Coachmarks schedule step one paragraph one',
  },
  stepOneParagraphOneMiddleSchool: {
    id: 'coachmarks.Schedule.Step.One.ParagraphOne.middleschool',
    defaultMessage:
      '<p>Talent tests for programs that require an assessment for admission are listed on this page.</p>',
    description: 'Coachmarks schedule step one paragraph one for Middle School',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Schedule.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>While you can submit your application before you’ve done a program’s assessment, you must at least schedule it or express your interest before you can add the program to your application. You’ll do that here.</p>',
    description: 'Coachmarks schedule step one paragraph two',
  },
  stepOneParagraphTwoMiddleSchool: {
    id: 'coachmarks.Schedule.Step.One.ParagraphTwo.middleschool',
    defaultMessage:
      "<p>If you registered to test, you'll receive your ticket in late December. If you expressed interest, upload your audition to the Additional Materials section in MySchools.</p>",
    description: 'Coachmarks schedule step one paragraph two for Middle School',
  },
  stepTwo: {
    id: 'coachmarks.Schedule.Step.Two',
    defaultMessage:
      '<p>If you have yet to schedule a program’s assessment or express your interest, you can do so here.</p><p>Tap or click this button and follow the steps to complete the request.</p><p>The school may contact you to schedule (or reschedule if necessary) a time for your assessment.</p>',
    description: 'Coachmarks schedule step two',
  },
  stepTwoMiddleSchool: {
    id: 'coachmarks.Schedule.Step.Two.middleschool',
    defaultMessage:
      "<p>Don't forget to check that the program has been added to your application after registering or expressing interest.</p><p>Tap or click this button and follow the steps to complete the registration.</p>",
    description: 'Coachmarks schedule step two for Middle School',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphOne',
    defaultMessage:
      '<p>Check your Scheduled list to review any programs you’ve scheduled assessments for, or expressed interest in.</p>',
    description: 'Coachmarks schedule step three paragraph one',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphTwo',
    defaultMessage:
      '<p>You can return here at any time to find dates, time, and locations for assessments you scheduled online. If you express interest and the school then contacts you to schedule, be sure to keep track of that appointment yourself!</p>',
    description: 'Coachmarks schedule step three paragraph two',
  },
  stepThreeParagraphOneMiddleSchool: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphOne.middleschool',
    defaultMessage: '<p>Here you can see the programs you’re registered to test for at Mark Twain.</p>',
    description: 'Coachmarks schedule step three paragraph one for Middle School',
  },
  stepThreeParagraphTwoMiddleSchool: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphTwo.middleschool',
    defaultMessage:
      '<p>You can return here once you’ve been notified by email that you’ve been assigned an appointment to find dates, times, and locations for assessments.</p>',
    description: 'Coachmarks schedule step three paragraph two for Middle School',
  },
  stepFour: {
    id: 'coachmarks.Schedule.Step.Four',
    defaultMessage:
      'Remember, just because a program you’ve saved is shown on this page does not mean you have to schedule an assessment for it — only if you definitely want to apply to it!',
    description: 'Coachmarks schedule step four',
  },
});
